// assets
import { DollarOutlined, HistoryOutlined, LockOutlined, SafetyCertificateOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';

// icons
const icons = { UserOutlined, SafetyCertificateOutlined, DollarOutlined, TeamOutlined, HistoryOutlined, LockOutlined };

// ==============================|| MENU ITEMS - ADMINISTRACIÓN ||============================== //

const administracion = {
  id: 'group-administracion',
  title: 'Administración',
  type: 'group',
  children: [
    { id: 'usuarios', title: 'Usuarios', type: 'item', url: '/usuarios', icon: icons.UserOutlined, permission: 'usuarios.read' },
    {
      id: 'roles',
      title: 'Roles y permisos',
      type: 'item',
      url: '/roles',
      icon: icons.SafetyCertificateOutlined,
      permission: 'roles.read'
    },
    // Módulo de trabajadores abierto sin restricción de permiso temporal.
    {
      id: 'trabajadores',
      title: 'Gestión de trabajadores',
      type: 'item',
      url: '/trabajadores',
      icon: icons.TeamOutlined
    },
    // Bloqueo de la app móvil (US-001): apps bloqueadas de las rutas del perfil y su desbloqueo.
    // Independiente de la vinculación de dispositivos (Gestión de trabajadores).
    {
      id: 'bloqueos',
      title: 'Bloqueos de la app',
      type: 'item',
      url: '/bloqueos',
      icon: icons.LockOutlined,
      permission: 'bloqueos.read'
    },
    // Cobro del uso de la plataforma a las unidades (PROP-002). No va en el
    // grupo Recaudo: ese es el cobro operativo de cartera a los clientes.
    // Mientras `plataforma.read` no exista en el backend, Navigation lo oculta.
    {
      id: 'plataforma-cobro',
      title: 'Cobro de la plataforma',
      type: 'item',
      url: '/plataforma/cobro',
      icon: icons.DollarOutlined,
      permission: 'plataforma.read'
    },
    // Registro de actividad / auditoría (US-009). "Logs" es el nombre técnico
    // del backend (GET /v1/logs); el nombre visible es "Registro de actividad".
    {
      id: 'registro-actividad',
      title: 'Registro de actividad',
      type: 'item',
      url: '/registro-actividad',
      icon: icons.HistoryOutlined,
      permission: 'logs.read'
    }
  ]
};

export default administracion;
